import React from 'react';
import { Grid, Row, Col } from '../../ui/Grid';
import Button from '../../ui/Button';
import VariantSearch from '../../VariantSearch';
import Link from '../../Link';
import { STATIC_HOST_URL } from '../../../settings';

interface StylesType {
  root: React.CSSProperties;
  container: React.CSSProperties;
  title: React.CSSProperties;
  centerContainer: React.CSSProperties;
  downloadButtonContainer: React.CSSProperties;
  disclaimer: React.CSSProperties;
}

const DISLandingPage: React.FC = () => {
  const styles: StylesType = {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    container: {
      margin: 'auto 0',
      padding: '30px 10px 50px',
      minWidth: '10px',
    },
    title: {
      marginBottom: '30px',
    },
    centerContainer: {
      width: '90%',
      margin: 'auto',
      textAlign: 'center',
    },
    downloadButtonContainer: {
      margin: '30px 0 20px',
    },
    disclaimer: {
      textAlign: 'center',
    },
  };

  return (
    <div style={styles.root}>
      <Grid fluid={false}>
        <Row>
          <Col md={12}>
            <div style={styles.container}>
              <div style={styles.centerContainer}>
                <h3 style={styles.title}>
                  Whole-genome deep-learning analysis reveals causal role of
                  noncoding mutations in autism
                </h3>
                <p>
                  Explore the predicted effects of 127,140 autism proband
                  mutations from Simons Simplex Collection whole genome
                  sequencing data.
                </p>
                <p>
                  <Link to="/asdbrowser">View as genome browser</Link>
                </p>
                <div style={styles.downloadButtonContainer}>
                  <Button
                    target="_blank"
                    href={`${STATIC_HOST_URL}variants/dis_asd.tsv`}
                  >
                    <i className="fa fa-download" /> Download data
                  </Button>
                </div>
                <p style={styles.disclaimer}>
                  The use of Simons Simplex Collection (and Simons VIP) data
                  sets is limited to projects related to advancing the field of
                  autism and related developmental disorder research. Questions
                  regarding content should be directed to collections@sfari.org.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <div style={styles.container}>
            <VariantSearch staticParams="labels__name=asd" showFeatures="asd" />
          </div>
        </Row>
      </Grid>
    </div>
  );
};

export default DISLandingPage;
